import { Link, NavLink, Navigate, Outlet, useLocation } from "react-router-dom";
import { ShoppingBag, User, LogOut } from "lucide-react";
import { useMember } from "@/context/MemberContext";
import { AtlLogo } from "@/components/store/Brand";

export function StoreFooter() {
  return (
    <footer className="border-t border-slate-200 bg-white" data-testid="store-footer">
      <div className="mx-auto flex max-w-7xl flex-col gap-2 px-5 py-8 text-sm text-slate-500 sm:flex-row sm:items-center sm:justify-between sm:px-8">
        <span>© {new Date().getFullYear()} ATL Wellness · Private members store</span>
        <span>Prices in AUD · Bank transfer payments</span>
      </div>
    </footer>
  );
}

function NavItem({ to, children, testid }) {
  return (
    <NavLink to={to} data-testid={testid}
      className={({ isActive }) => `rounded-lg px-3 py-2 text-sm font-medium transition-colors ${isActive ? "bg-sky-50 text-slate-900" : "text-slate-600 hover:text-slate-900"}`}>
      {children}
    </NavLink>
  );
}

export function MemberRoute({ children }) {
  const { member } = useMember();
  const loc = useLocation();
  if (member === null) return <div className="flex h-screen items-center justify-center text-slate-500">Loading…</div>;
  if (!member) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname)}`} replace />;
  return children;
}

export default function StoreLayout() {
  const { member, logout, cartCount } = useMember();
  const doLogout = () => { logout(); window.location.replace("/"); };
  return (
    <div className="flex min-h-screen flex-col bg-[#F8FAFC]">
      <header className="sticky top-0 z-30 border-b border-slate-200 bg-white/90 backdrop-blur-md">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-3 px-5 sm:px-8">
          <AtlLogo to="/shop" />
          <nav className="flex items-center gap-1">
            <span className="hidden sm:inline-flex"><NavItem to="/shop" testid="nav-shop">Shop</NavItem></span>
            <NavItem to="/account" testid="nav-account">
              <span className="flex items-center gap-1.5"><User className="h-4 w-4" /><span className="hidden sm:inline">{member?.name?.split(" ")[0] || "Account"}</span></span>
            </NavItem>
            <Link to="/cart" data-testid="nav-cart" className="relative ml-1 flex h-10 w-10 items-center justify-center rounded-lg bg-[#89CFF0] text-slate-900 transition-colors hover:bg-[#74C2EC]">
              <ShoppingBag className="h-[18px] w-[18px]" />
              {cartCount > 0 && <span data-testid="nav-cart-count" className="absolute -right-1.5 -top-1.5 flex h-5 min-w-5 items-center justify-center rounded-full bg-slate-900 px-1 text-[11px] font-bold text-white">{cartCount}</span>}
            </Link>
            <button onClick={doLogout} data-testid="nav-logout" className="ml-1 flex h-10 w-10 items-center justify-center rounded-lg text-slate-500 transition-colors hover:bg-slate-100 hover:text-slate-900" title="Log out">
              <LogOut className="h-[18px] w-[18px]" />
            </button>
          </nav>
        </div>
      </header>
      <main className="mx-auto w-full max-w-7xl flex-1 px-5 py-8 sm:px-8 sm:py-10"><Outlet /></main>
      <StoreFooter />
    </div>
  );
}
